/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState} from 'react'
import {Link} from 'react-router-dom'
import {useAuth, UserModel} from '../../../../app/modules/auth'
import {useIntl} from 'react-intl'

import {Languages} from './Languages'
import {toAbsoluteUrl} from '../../../helpers'
import {HeaderThema} from './HeaderThema'

const HeaderUserMenu: FC = () => {
  const {currentUser, logout} = useAuth()
  const user = currentUser as UserModel
  const timestamp = new Date().getTime()
  const [userImage, setUserImage] = useState(
    user.picture ? user.picture + '?' + timestamp : toAbsoluteUrl('/media/avatars/blank.png')
  )
  const [showChangePasswordModal, setChangePasswordModal] = useState(false)
  const intl = useIntl()

  //in your component
  function erroImagem() {
    setUserImage(toAbsoluteUrl('/media/avatars/blank.png'))
    //   user.pic= toAbsoluteUrl('/media/avatars/blank.png')
  }
  console.log(currentUser)

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <a href='#' data-bs-toggle='modal' data-bs-target='#kt_modal_editImagePerfil'>
            <div className='symbol symbol-35px me-5 rounded-circle'>
              <img
                className='rounded-circle border border-gray-300'
                alt='Logo'
                src={userImage}
                onError={erroImagem}
              />
            </div>
          </a>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {currentUser?.firstname} {currentUser?.lastname}
              {/* <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>Pro</span> */}
            </div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-8'>
              {currentUser?.email}
            </a>
          </div>
        </div>
      </div>

      {/* <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <Link to={'/crafted/pages/profile'} className='menu-link px-5'>
          {intl.formatMessage({id: 'USER.PROFILE'})}
        </Link>
      </div>

      <div className='separator my-2'></div> */}

      <Languages />

      <div className='menu-item px-5 my-1'>
        <Link to='/crafted/account/settings' className='menu-link px-5'>
          {intl.formatMessage({id: 'USER.CHANGE_PASSWORD'})}
        </Link>
      </div>

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          {intl.formatMessage({id: 'USER.SIGNOUT'})}
        </a>
      </div>
      <div className='separator'></div>
      <div className='d-flex flex-column border border-light rounded-top rounded-bottom'>
        <HeaderThema />
      </div>
    </div>
  )
}

export {HeaderUserMenu}
